import React from "react";

import { useIntl } from "gatsby-plugin-react-intl";

import { ReactComponent as IconPause18 } from "../../icons/icon/18/a-icon-pause-18.svg";
import { ReactComponent as IconVideo18 } from "../../icons/icon/18/a-icon-video-18.svg";
import IconButton from "../button/iconButton";

interface PlayButtonProps {
  playing: boolean;
  setPlaying: React.Dispatch<React.SetStateAction<boolean>>;
}

const PlayButton: React.FC<PlayButtonProps> = ({ playing, setPlaying }) => {
  const intl = useIntl();

  return (
    <IconButton
      onClick={() => setPlaying((prevState) => !prevState)}
      iconOnly
      className="video-background-player__play-button"
      variant="inverted-light"
      title={intl.formatMessage({ id: playing ? "video.toggle_pause.title" : "video.toggle_play.title" })}
    >
      {playing ? <IconPause18 /> : <IconVideo18 />}
    </IconButton>
  );
};

export default PlayButton;
